import PropTypes from 'prop-types';
export var OrderPaymentStatus = /*#__PURE__*/function (OrderPaymentStatus) {
  OrderPaymentStatus["Succeeded"] = "succeeded";
  OrderPaymentStatus["Failed"] = "failed";
  return OrderPaymentStatus;
}({});
export var OrderPropTypes = PropTypes.shape({
  id: PropTypes.string.isRequired,
  date: PropTypes.string.isRequired,
  grandTotal: PropTypes.string.isRequired,
  message: PropTypes.string,
  status: PropTypes.oneOf([OrderPaymentStatus.Failed, OrderPaymentStatus.Succeeded]).isRequired
}).isRequired;